export const routeName = 'ReclamationDetailsPage'

export const route = {
  path: '/reclamation/details/:id',
  name: routeName,
  component: () => import('./ReclamationDetailsPage.vue')
}
